import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { CanActivate, Router } from "@angular/router";
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { LoaderService } from "../common/loadingBar/loader.service";

@Injectable()
export class LoginService extends AuthService{
  
  public subject = new Subject();
  public subject$ = this.subject.asObservable();
  private URLChangePass = "api/v1/updateUserPassword/";
  constructor(public http: Http, public router: Router) {
    super(http,router);

  }

  public login(data) {
    return this.http.post(this.APIURL + this.urlAuth, data)
        .map(
          (res: Response) => {
          this.saveOnLocalStorage(res.json());
          }
      );
  }

  public logout() {
      localStorage.removeItem("user");
      this.router.navigate(["/login"]);
      this.setLoginTrue(false);
  }

  public canActivate() {

    if(this.getUserLogued()){
      return this.getUserLogued();
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }

  public getUserManager(){
    var user = this.getFromLocalStorage();
    return user["user"];
  }

  public updatePassword(data: object){
        return this.http.post(this.APIURL + this.URLChangePass, data, { headers: this.headers})
        .map((res: Response) => res.json()["status"]);
  }

}


// WEBPACK FOOTER //
// ./src/app/injections/login.service.ts